import request from "@/http";
/**
 * 获取可提现金额
 * @param {*} data
 * @returns
 */
const getWithDrawalMoney = (data) => {
  let { begin_idx, limit, type_order = 1, isloading = false } = data;
  return request.get({
    url: "duzikai_api_customer_public_statistic_mgr",
    data: {
      invoke_method: "statis_4_one_user",
      pre_db_para_begin_idx: begin_idx,
      pre_db_para_length_4_list: limit,
      type_order: type_order,
    },
    loading: {
      enabled: isloading,
    },
  });
};
/**
 * 获取交易记录
 * @param {*} data
 * @returns
 */
const getConsumeRecord = (data) => {
  let {
    begin_idx,
    limit,
    buyer_id,
    consume_type,
    isloading = false,
    type_order = 1,
    seller_id = 99101,
  } = data;
  return request.get({
    url: "duzikai_api_mgr_consume_record",
    data: {
      invoke_method: "public_page_4m_consume_list",
      pre_db_para_begin_idx: begin_idx,
      pre_db_para_length_4_list: limit,
      buyer_id: buyer_id,
      seller_id: seller_id,
      consume_type: consume_type,
      sequence_order_is_null: true,
    },
    loading: {
      enabled: isloading,
    },
  });
};

/**
 * 获取交易记录
 * @param {*} data
 * @returns
 */
const getWithDrawalRecord = (data) => {
  let {
    begin_idx,
    limit,
    id_public_user_info,
    isloading = false,
    type_middle_app = 20002,
    type_inner_app = 1001,
    middle_table_name = "public_middle_table_20002",
    is_online = 0,
  } = data;
  return request.get({
    url: "duzikai_api_mgr_public_middle_table",
    data: {
      invoke_method: "public_load_middle_table_list",
      pre_db_para_begin_idx: begin_idx,
      pre_db_para_length_4_list: limit,
      type_middle_app: type_middle_app,
      type_inner_app: type_inner_app,
      middle_table_name: middle_table_name,
      id_public_user_info: id_public_user_info,
      is_online: is_online,
    },
    loading: {
      enabled: isloading,
    },
  });
};

/**
 * 提交提现申请
 * @param {*} data
 * @returns
 */
const submitApply = (data) => {
  let {
    consume_price,
    consume_remark,
    buyer_id,
    user_type,
    time_consume,
    consume_remark_004,
    consume_remark_005,
    isloading = false,
  } = data;
  return request.get({
    url: "duzikai_api_mgr_consume_record",
    data: {
      invoke_method: "public_page_4m_insert_or_upd_consume_record",
      consume_price: -consume_price,
      consume_remark: consume_remark,
      user_type: user_type,
      buyer_id: buyer_id,
      consume_status: 901,
      consume_type: 201,
      is_online: 0,
      id_public_data_admin_user: 800,
      seller_id: 99101,
      // time_consume: time_consume,
      consume_remark_004: consume_remark_004,
      consume_remark_005: consume_remark_005,
      pre_cmd_para_check_exist_apply: true,
    },
    loading: {
      enabled: isloading,
    },
  });
};

export default {
  getWithDrawalMoney,
  getConsumeRecord,
  getWithDrawalRecord,
  submitApply,
};
